import React from "react";
import { useNavigate } from "react-router-dom";
import SectionTitle from "../../../assets/components/TitleGroup";
import { SplitRowHalf } from "../../../assets/components/ButtonGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";

const buildRows = (preview) => {
  const menus = [preview?.menu_1, preview?.menu_2, preview?.menu_3]
    .filter(Boolean)
    .join(", ");

  const category = [
    preview?.main_category_name,
    preview?.sub_category_name,
    preview?.detail_category_name,
  ]
    .filter(Boolean)
    .join(" > ");

  return [
    { label: "이름", value: preview?.user_name || "-" },
    { label: "휴대폰번호", value: preview?.phone || "-" },
    { label: "매장명", value: preview?.store_name || "-" },
    { label: "주소", value: preview?.road_name || "-" },
    { label: "업종", value: category || "-" },
    { label: "주요 메뉴", value: menus || "-" },
  ];
};

const AdsRegistConciergeConfirm = ({
  preview,
  setStep6Shop,
  goToStep,
  targetStoreRegister,
}) => {
  const navigate = useNavigate();
  const { footerRef, bottomSpace } = useFixedLayout();

  const handleConfirm = () => {
    if (!preview?.store_business_number) {
      window.alert(
        "컨시어지 매장 연결 정보를 확인할 수 없습니다. 고객지원으로 문의해 주세요."
      );
      return;
    }

    setStep6Shop({
      STORE_NAME: preview.store_name,
      ROAD_NAME_ADDRESS: preview.road_name,
      STORE_BUSINESS_NUMBER: preview.store_business_number,
      LARGE_CATEGORY_NAME: preview.main_category_name || "",
      MEDIUM_CATEGORY_NAME: preview.sub_category_name || "",
      SMALL_CATEGORY_NAME: preview.detail_category_name || "",
      REPRESENTATIVE_MENU: [preview?.menu_1, preview?.menu_2, preview?.menu_3]
        .filter(Boolean)
        .join(","),
      FLOOR_INFO: "",
    });
    goToStep(targetStoreRegister);
  };

  const infoRows = buildRows(preview);

  return (
    <div className="flex h-full flex-col">
      <div
        className="flex flex-1 flex-col px-[16px] pt-[16px]"
        style={{ paddingBottom: bottomSpace }}
      >
        <SectionTitle
          title="컨시어지 등록 정보 확인"
          subTitle="앱 가입에 사용할 컨시어지 등록 정보를 확인해 주세요. 정보가 다르면 수정 요청으로 이동해 주세요."
          className="pb-[32px]"
        />

        <div className="overflow-hidden rounded-[20px] border border-border-subtle bg-surface-light-white">
          {infoRows.map((item, index) => (
            <div
              key={item.label}
              className={`px-[16px] py-[14px] ${
                index !== infoRows.length - 1 ? "border-b border-border-subtle" : ""
              }`}
            >
              <div className="mb-[4px] text-c2 text-text-subtler">{item.label}</div>
              <div className="break-words text-b1 text-text-default">{item.value}</div>
            </div>
          ))}
        </div>
      </div>

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 bg-surface-default">
        <SplitRowHalf
          leftText="수정 요청"
          rightText="확인"
          leftType="border"
          rightType="fill"
          onLeft={() => navigate("/ads/support")}
          onRight={handleConfirm}
        />
      </div>
    </div>
  );
};

export default AdsRegistConciergeConfirm;
